/*
 * ProjectActivityListPage Messages
 *
 * This contains all the text for the ProjectsPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.publications';

export default defineMessages({
  COMPLETED: {
    id: `${scope}.completed`,
    defaultMessage: 'COMPLETED',
  },
  PEARSONPLUS_TITLE_INGEST_COMPLETE: {
    id: `${scope}.ingestionCompleted`,
    defaultMessage: 'Ing. Completed',
  },
  INDEX_IN_PROGRESS: {
    id: `${scope}.indexingInProgress`,
    defaultMessage: 'Indexing',
  },
  FAILED: {
    id: `${scope}.failed`,
    defaultMessage: 'FAILED',
  },
  INPROGRESS: {
    id: `${scope}.export.inprogress`,
    defaultMessage: 'IN PROGRESS',
  },
  STARTED: {
    id: `${scope}.publish.started`,
    defaultMessage: 'PUBLISHING',
  },
  UNKNOWN: {
    id: `${scope}.publish.status.unknown`,
    defaultMessage: 'UNKNOWN',
  },
  CONTENT_NOT_CHANGED: {
    id: `${scope}.publish.content.not.changed`,
    defaultMessage: 'No content change detected',
  },
  10005: {
    id: `${scope}.errorcode.export.failed`,
    defaultMessage: 'Export Service failed to generate Ambrosia file',
  },
  10006: {
    id: `${scope}.errorcode.export.failed`,
    defaultMessage: 'Export inprogress',
  },
  10007: {
    id: `${scope}.errorcode.isbn.notfound`,
    defaultMessage: 'Parent ISBN does not exist',
  },
  10008: {
    id: `${scope}.errorcode.isbn.incomplete`,
    defaultMessage: 'One ePub Subscription ISBN and one ePub 2-download ISBN within the program family of the title in PDH is required',
  },
  10003: {
    id: `${scope}.errorcode.transformation.failed`,
    defaultMessage: 'ePub Generator failed to generate ePub',
  },
  10004: {
    id: `${scope}.errorcode.publish.failed`,
    defaultMessage: 'ePub Generator failed to ingest into Oculus',
  },
  10009: {
    id: `${scope}.errorcode.publish.failed`,
    defaultMessage: 'Invalid parent OLP ISBN',
  },
  10010: {
    id: `${scope}.errorcode.publish.failed`,
    defaultMessage: 'There cannot be more than one ePub Subscription ISBN or ePub 2-download ISBN in the same product family in PDH',
  },
  10011: {
    id: `${scope}.errorcode.publish.failed`,
    defaultMessage: 'subscription / 2-download ISBN does not exist / is expired / is cancelled',
  },
  10012: {
    id: `${scope}.errorcode.publish.failed`,
    defaultMessage: 'Missing screen title',
  },
  10013: {
    id: `${scope}.code.publish.missingalfrescosite.failed`,
    defaultMessage: 'Missing Alfresco Site in Project Settings',
  },
  10014: {
    id: `${scope}.code.publish.missinguserinsite.failed`,
    defaultMessage: 'Missing Service Account in the target Alfresco Site',
  },
  10015: {
    id: `${scope}.code.publish.validation.failed`,
    defaultMessage: 'Error while Validating the epub',
  },
  10016: {
    id: `${scope}.code.publish.validation.failed`,
    defaultMessage: 'ePub Has Fatal Errors',
  },
  10002: {
    id: `${scope}.code.publish.inprogress`,
    defaultMessage: 'Publish inprogress',
  },
  10001: {
    id: `${scope}.code.publish.success`,
    defaultMessage: 'Publish completed',
  },
  0: {
    id: `${scope}.errorcode.unknown`,
    defaultMessage: 'Unknown reason',
  },
  20001: {
    id: `${scope}.code.publish.success`,
    defaultMessage: 'Publish completed',
  },
  20002: {
    id: `${scope}.code.publish.inprogress`,
    defaultMessage: 'Publish inprogress',
  },
  20003: {
    id: `${scope}.code.bv.publish.ambrosia.failed`,
    defaultMessage: 'Failed to generate offline package (Reduce Ambrosia Lambda failed).',
  },
  20004: {
    id: `${scope}.errorcode.offlinepackage.publish.failed`,
    defaultMessage: 'Failed to publish to Pearson Plus.',
  },
  20005: {
    id: `${scope}.code.bv.publish.assets.failed`,
    defaultMessage: 'Failed to generate offline package (Copy Assets Lambda failed).',
  },
  20006: {
    id: `${scope}.code.bv.publish.plugins.failed`,
    defaultMessage: 'Failed to generate offline package (Copy Plugins Lambda failed).',
  },
  20007: {
    id: `${scope}.code.bv.publish.toc.failed`,
    defaultMessage: 'Failed to generate offline package (Generate TOC Lambda failed).',
  },
  20008: {
    id: `${scope}.code.bv.publish.package.failed`,
    defaultMessage: 'Failed to generate offline package (Zip Package Lambda failed).',
  },
  20009: {
    id: `${scope}.code.bv.publish.csg.element.indexing.failed`,
    defaultMessage: 'CSG Element Indexing Lambda failed',
  },
  20010: {
    id: `${scope}.code.bv.publish.csg.glossary.indexing.failed`,
    defaultMessage: 'CSG Glossary Indexing Lambda failed',
  },
  20011: {
    id: `${scope}.code.bv.publish.csg.step.failed`,
    defaultMessage: 'CSG Step Complete Lambda failed',
  },
  20012: {
    id: `${scope}.code.bv.publish.csg.indexing.not.completed`,
    defaultMessage: 'Not Completed',
  },
  20013: {
    id: `${scope}.code.bv.publish.csg.indexing.in.progress`,
    defaultMessage: 'Indexing in Progress',
  },
  20014: {
    id: `${scope}.code.bv.publish.indexing.failed`,
    defaultMessage: 'Failed to index course (Errors occurred during CSG indexing)',
  },
  30001: {
    id: `${scope}.code.indesignpublish.success`,
    defaultMessage: 'InDesign Publish completed',
  },
  30002: {
    id: `${scope}.code.indesignpublish.inprogress`,
    defaultMessage: 'InDesign Publish inprogress',
  },
  30003: {
    id: `${scope}.code.indesignpublish.transform.failed`,
    defaultMessage: 'InDesign package generation failed.',
  },
  30004: {
    id: `${scope}.code.indesignpublish.publish.failed`,
    defaultMessage: 'InDesign Publish Failed.',
  },
  30005: {
    id: `${scope}.code.indesignpublish.missingalfrescosite.failed`,
    defaultMessage: 'Missing Alfresco Site in Project Settings',
  },
  30006: {
    id: `${scope}.code.indesignpublish.missinguserinsite.failed`,
    defaultMessage: 'Missing Service Account in the target Alfresco Site',
  },
});
